import { render, staticRenderFns } from "./AppAvatar.vue?vue&type=template&id=7d996dd0&scoped=true"
import script from "./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue?vue&type=script&lang=js"
import style0 from "./AppAvatar.vue?vue&type=style&index=0&id=7d996dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d996dd0",
  null
  
)

export default component.exports